<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let tags = [];

  function click(tag) {
    if (!tag) {
      dispatch("change", {
        list: [],
        removed: undefined,
      });
      return;
    }
    let list = tags.filter((x) => x);
    if ((tag, typeof tag == "string")) {
      list = list.filter((x) => x.id != tag);
    }
    dispatch("change", {
      list,
      removed: tag,
    });
  }

  function get_tag_details(tag) {
    if (!tag.details) {
      return "";
    }
    // range
    if (Array.isArray(tag.details)) {
      return tag.details.join(",");
    }
    const keys = Object.keys(tag.details)
      .map((id) => tag.details[id]?.key)
      .filter((x) => x);
    return keys.join(", ");
  }
</script>

<section>
  {#if tags && tags.length > 0}
  <h2 class="h2">{window.__('facet.active_filters')}</h2>
    <button
      on:click={() => {
        click();
      }}
      ><span class="text">{window.__("facet.clear")}</span>
      <span class="icon-close" /></button
    >
    {#each tags as tag}
      {@const details = get_tag_details(tag)}
      <button
        class="filter"
        on:click={() => {
          click(tag.id);
        }}
      >
        {#if tag.details === false}
          {window.__("facet.not_key", { key: tag.name })}
        {:else}
          {tag.name}
        {/if}
        <span>{details}</span>
        <span class="icon-close" />
      </button>
    {/each}
  {/if}
</section>


<style>section {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-size: 0;
    line-height: 0;
    padding: 0.5rem 0;
}

button {
    border: 0;
    background: var(--color-primary);
    color: var(--button__active__color);
    display: inline-block;
    padding: 0.2em 0.5em;
    cursor: pointer;
    margin: 0 0.2rem 0.2rem 0;
    font-size: 1rem;
    line-height: 1.2rem;
    text-align: left;
}
  section {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-size: 0;
    line-height: 0;
    padding: 16px 0px;
  }

  button {
    border: 0;
    background: var(--color-primary);
    color: var(--button__active__color);
    display: inline-block;
    padding: 0.2em 0.5em;
    cursor: pointer;
    margin: 0 0.2rem 0.2rem 0;
    font-size: 1rem;
    line-height: 1.2rem;
    text-align: left;
  }
  .icon-close {
    font-size: 0.5rem;
    margin-left: 10px;
    top: -2px;
    position: relative;
  }
  button .text {
    font-family: "Open Sans";
  }
  h2{
    display: block;
    width: 100%;
  }
</style>